export const getNumeric = (value) => value.replace(/\D/g, '');

export const zipCodeDisplayFormatter = (value) => {
  const numericString = getNumeric(value);
  if (!numericString) {
    return '';
  }

  return numericString.substr(0, 5);
};

export const phoneDisplayFormatter = (value) => {
  const numericString = getNumeric(value);
  if (!numericString) {
    return '';
  }
  const firstThree = numericString.substr(0, 3);
  const areaCode = `(${firstThree})`;
  const secondThree = numericString.substr(3, 3);
  if (!secondThree) {
    return areaCode;
  }
  const lastFour = numericString.substr(6, 4);
  if (!lastFour) {
    return `${areaCode}-${secondThree}`;
  }

  return `${areaCode}-${secondThree}-${lastFour}`;
};

export const dateFormatter = (date) => {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  const targetDate = new Date(date);

  const diffTime = currentDate - targetDate;
  const diffDays = Math.floor(Math.abs(diffTime / (1000 * 60 * 60 * 24)));

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';

  const currentWeekDay = currentDate.getDay(); // 0 (Sun) to 6 (Sat)
  const startOfWeek = new Date(currentDate);
  startOfWeek.setDate(currentDate.getDate() - currentWeekDay);
  startOfWeek.setHours(0, 0, 0, 0);

  if (targetDate >= startOfWeek) {
    return targetDate.toLocaleDateString('en-US', { weekday: 'long' }); // e.g., "Monday"
  }

  if (currentDate.getFullYear() === targetDate.getFullYear()) {
    return targetDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric' }); // e.g., "March 20"
  }

  return targetDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }); // e.g., "December 25, 2024"
};

export const ZIP_CODE_MASK = 'XXXXX';
export const PHONE_MASK = '(XXX)-XXX-XXXX';
